import { useMutation } from '@apollo/client';

import { UpdateUserCautionInput } from '../../apollo/__generated__/graphql';
import { UPDATE_USER_CAUTION } from '../graphql/mutation/updateUserCautionMutation.graphql';

export const useUpdateUserCautionMutation = () => {
  const [mutate] = useMutation(UPDATE_USER_CAUTION);

  const updateUserCaution = (
    updateUserCautionInput: UpdateUserCautionInput,
  ) => {
    mutate({
      variables: {
        updateUserCautionInput,
        eventId: updateUserCautionInput.eventId,
      },
    });
  };

  return { updateUserCaution };
};
